/**
 * Location action
 */
import {
  GET_LOCATION,
  GET_LOCATION_SUCCESS,
  GET_LOCATION_FAILURE,
  GET_ALL_LOCATIONS,
  GET_ALL_LOCATIONS_SUCCESS,
  GET_ALL_LOCATIONS_FAILURE,
  EDIT_LOCATION,
  EDIT_LOCATION_SUCCESS,
  EDIT_LOCATION_FAILURE,
  ADD_LOCATION,
  ADD_LOCATION_SUCCESS,
  ADD_LOCATION_FAILURE,
  REMOVE_LOCATION,
  REMOVE_FAILURE,
  TOGGLE_HIDDEN_LOCATION,
  TOGGLE_HIDDEN_LOCATION_SUCCESS,
  TOGGLE_HIDDEN_LOCATION_FAILURE,
  CONFIRM_ERROR_DELETE_POPUP,
  LOAD_MAP,
  INIT_STATE_LOCATION,
  REMOVE_SUCCESS,
  CLEAR_LOCATION_CACHE
} from './types';


export const getLocation = () => ({
  type: GET_LOCATION,
});

export const getLocationSuccess = response => ({
  type: GET_LOCATION_SUCCESS,
  payload: response,
});

export const getLocationFailure = error => ({
  type: GET_LOCATION_FAILURE,
  payload: error,
});

export const getAllLocations = () => ({
  type: GET_ALL_LOCATIONS,
});

export const getAllLocationsSuccess = response => ({
  type: GET_ALL_LOCATIONS_SUCCESS,
  payload: response,
});

export const getAllLocationsFailure = error => ({
  type: GET_ALL_LOCATIONS_FAILURE,
  payload: error,
});

export const addLocation = (newLocation, history) => ({
  type: ADD_LOCATION,
  payload: { newLocation, history },
});

export const addLocationSuccess = () => ({
  type: ADD_LOCATION_SUCCESS,
});

export const addLocationFailure = error => ({
  type: ADD_LOCATION_FAILURE,
  payload: error,
});

export const editLocation = (newLocation, history) => ({
  type: EDIT_LOCATION,
  payload: { newLocation, history },
});

export const editLocationSuccess = () => ({
  type: EDIT_LOCATION_SUCCESS,
});

export const editLocationFailure = error => ({
  type: EDIT_LOCATION_FAILURE,
  payload: error,
});

export const toggleHiddenLocation = (locationId, hidden) => ({
  type: TOGGLE_HIDDEN_LOCATION,
  payload: { locationId, hidden },
});

export const toggleHiddenLocationSuccess = () => ({
  type: TOGGLE_HIDDEN_LOCATION_SUCCESS,
});

export const toggleHiddenLocationFailure = error => ({
  type: TOGGLE_HIDDEN_LOCATION_FAILURE,
  payload: error,
});

export const removeLocation = (id, history) => ({
  type: REMOVE_LOCATION,
  payload: { id, history },
});

export const removeSuccess = () => ({
  type: REMOVE_SUCCESS,
});

export const removeFailure = error => ({
  type: REMOVE_FAILURE,
  payload: error,
});

export const confirmErrorPopup = () => ({
  type: CONFIRM_ERROR_DELETE_POPUP,
});

export const LoadMap = () => ({
  type: LOAD_MAP,
});

export const initStateLocation = () => ({
    type: INIT_STATE_LOCATION
});

export const clearLocationCache = () => ({
    type: CLEAR_LOCATION_CACHE
});
